// extracted by mini-css-extract-plugin
module.exports = {"authLink":"auth-links_authLink__GkgxE","authButton":"auth-links_authButton__2qBhD","link":"auth-links_link__P_o1K","emailLink":"auth-links_emailLink__GKvKG"};